import type { Asset } from './asset';
import type { SearchProfile } from './searchProfile';

// AI modification tools (background replace/remove) require both that the
// asset itself is AI-editable and that the visitor's search profile carries
// custom media agreements - callers additionally gate on site config
// (whether the site's modification-tools menu is enabled at all), which is a
// site-differentiation concern and stays out of the domain layer.
export const isAiModificationToolsEligible = (
  asset: Asset,
  searchProfile: SearchProfile
): boolean => asset.isAiEditable && searchProfile.hasCustomMediaAgreements;
